import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getNiceDate } from '@iotv/datamodel';
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { TableCell, Typography } from '@mui/material';
import React from 'react';
import Assembler from '../../../data/Assembler';
import { ComponentMode } from '../../../types/AppTypes';
import { BooleanComponent } from './BooleanComponent';
import { EnumComponent } from './EnumComponent';
import { TextComponent } from './TextComponent';
import { DateInput } from './DateInput';
import { Link } from 'react-router-dom';
const debug = process.env.REACT_APP_DEBUG && false;
export const InputFieldArbitrator = ({ keyToUse, tableOb, viewKeyDefinition, mode, updateKV, functionOverrides, textFieldProps, }) => {
    debug && console.log('InputFieldArbitrator props', keyToUse, tableOb, viewKeyDefinition, mode);
    tableOb = (tableOb.type ? Assembler.getInstance(tableOb) : tableOb) ?? tableOb;
    const key = `${tableOb.sk}_${viewKeyDefinition.key}`;
    switch (mode) {
        case ComponentMode.VIEW:
            return (_jsxs(_Fragment, { children: [_jsx(TableCell, { component: 'th', scope: 'row', children: viewKeyDefinition.label }, key), _jsx(TableCell, { align: 'right', children: ViewFieldArbitrator({ tableOb, viewKeyDefinition }) }, `${key}_2`)] }));
        case ComponentMode.EDIT:
            return (_jsx(_Fragment, { children: _jsx(TableCell, { align: 'left', colSpan: 2, children: EditFieldArbitrator({ tableOb, updateKV, viewKeyDefinition, functionOverrides, textFieldProps }) }, key) }));
        default:
            return _jsx("div", {});
    }
};
export const EditFieldArbitrator = ({ tableOb, viewKeyDefinition, updateKV, functionOverrides, textFieldProps }) => {
    const key = `${tableOb.sk ?? 'newObject'}_${viewKeyDefinition.key}_EditComponent`;
    const mode = ComponentMode.EDIT;
    switch (viewKeyDefinition.type) {
        case AppValueTypes.ENUM:
            return _jsx(EnumComponent, { matchedPrimary: tableOb, viewKeyDefinition, mode, updateKV }, key);
        case AppValueTypes.BOOLEAN:
            return _jsx(BooleanComponent, { matchedPrimary: tableOb, viewKeyDefinition, mode, updateKV }, key);
        case AppValueTypes.OBJECT: {
            const embededObject = tableOb[viewKeyDefinition.key];
            return null;
        }
        case AppValueTypes.TIMESTAMP_MS:
            return (_jsx(DateInput, { matchedPrimary: tableOb,
                viewKeyDefinition,
                mode,
                updateKV,
                functionOverrides }, key));
        default:
            return _jsx(TextComponent, { matchedPrimary: tableOb, viewKeyDefinition, mode, updateKV, functionOverrides, textFieldProps }, key);
    }
};
export const ViewFieldArbitrator = ({ tableOb, viewKeyDefinition, linkTo }) => {
    const key = `${tableOb.sk ?? 'newObject'}_${viewKeyDefinition.key}_ViewComponent`;
    const value = tableOb[viewKeyDefinition.key];
    const mode = ComponentMode.VIEW;
    const updateKV = () => {
        console.log('WARN: A view field called updateKV on ViewFieldArbitrator');
    };
    const derivedValue = viewKeyDefinition.valueGetter ? viewKeyDefinition.valueGetter(tableOb[viewKeyDefinition.key], tableOb) : tableOb[viewKeyDefinition.key];
    const defaultTextField = _jsx(Typography, { children: derivedValue });
    switch (viewKeyDefinition.type) {
        case AppValueTypes.ENUM:
            return _jsx(EnumComponent, { matchedPrimary: tableOb, viewKeyDefinition, mode, updateKV }, key);
        case AppValueTypes.BOOLEAN:
            return _jsx(BooleanComponent, { matchedPrimary: tableOb, viewKeyDefinition, mode, updateKV }, key);
        //case AppValueTypes.OBJECT: return <div>{JSON.stringify(matchedPrimary)}</div>
        case AppValueTypes.OBJECT: {
            const embededObject = tableOb[viewKeyDefinition.key];
            return null;
        }
        case AppValueTypes.DATE:
            return value ? getNiceDate(new Date(value).valueOf(), { dateStyle: 'short' }) : value;
        default:
            return linkTo ? wrapInputFieldWithLink(defaultTextField, linkTo) : defaultTextField;
    }
};
const wrapInputFieldWithLink = (element, to) => _jsx(Link, { to, children: element });
